"use client";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import Image from "next/image";

const Hero = ({ data }) => {
  return (
    <Carousel
      opts={{
        align: "center",
        loop: true,
      }}
      plugins={[
        Autoplay({
          delay: 5000,
        }),
      ]}
      className="w-full"
    >
      <CarouselContent>
        {data?.map((data, index) => (
          <CarouselItem key={index} className="pl-0">
            <div className="relative w-full aspect-[2.4/1] lg:h-[300px] overflow-hidden">
              <Image
                src={data?.image}
                alt="hero section"
                fill
                className="object-cover"
                quality={100}
                priority={index === 0}
              />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default Hero;